export default "__VITE_ASSET__b5114cac__"